// "Previous lives" survive new games: stored separately from the save (per browser).
import type { GameState } from "@degen/sim/state";
import { rankName } from "@degen/sim/rank";

export interface PastLife {
  name: string;
  handle: string;
  origin: string;
  days: number;
  peakNetWorth: number;
  rank: string;
  endedAs: string;
}

const KEY = "degen-world:lives";

export function loadLives(): PastLife[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "[]") as PastLife[];
  } catch {
    return [];
  }
}

export function recordLife(s: GameState, endedAs: string) {
  const p = s.player;
  const lives = loadLives();
  lives.unshift({ name: p.name, handle: p.handle, origin: p.origin, days: p.stats.daysPlayed, peakNetWorth: s.rekt?.peakNetWorth ?? p.stats.peakNetWorth, rank: rankName(p.rank), endedAs });
  try {
    localStorage.setItem(KEY, JSON.stringify(lives.slice(0, 20)));
  } catch {
    /* storage full or blocked: lives are a nice-to-have */
  }
}
